import { set } from '@/utils/vuex.js'

export default {
  SET_FILTER: set('filter'),
  SET_PERMISSIONS: set('permissions'),
  SET_LOADED_INIT: set('loaded_init')
}
